/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function EnterKey({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M14 2H8V1h6.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H2v-1h12z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="m2.207 11.5 2.647-2.646-.708-.708-3 3a.5.5 0 0 0 0 .708l3 3 .708-.708z" clipRule="evenodd" /></svg>;
}
;